/*=========================================================================================
  File Name: moduleCalendarActions.js
  Description: Calendar Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import axios from '@/axios.js'

export default {
  fetchConfigs({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get('/configs/')
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchConfig(context, configId) {
    return new Promise((resolve, reject) => {
      axios.get(`/configs/${configId}`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  updateConfig({ commit }, { configId, item }) {
    return new Promise((resolve, reject) => {
      console.log(item)
      axios.put(`/configs/${configId}`, item)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  updateConfigs({ commit }, { configId, item }) {
    return new Promise((resolve, reject) => {
      console.log(item)
      axios.put(`/configs/${configId}/`, item)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  }
}
